import React, { useEffect, useState } from "react";

import CursorProvider from "./components/cursor/CursorProvider";
import HomeSection from "./sections/HomeSection";
import ExperienceSection from "./sections/ExperienceSection";
import ProjectsSection from "./sections/ProjectsSection";
import ContactSection from "./sections/ContactSection";
import SmoothScroll from "./components/animations/SmoothScroll";
import FloatingDock from "./components/navigation/FloatingDock";
import Preloader from "./components/loader/Preloader";

const LOADER_EXIT_DURATION = 1600;

function V2Layout() {
  const [activeSection, setActiveSection] = useState("home");
  const [showDock, setShowDock] = useState(true);
  const [isNavigating, setIsNavigating] = useState(false);

  // Controls the Hero/site movement
  const [loaderExiting, setLoaderExiting] = useState(false);

  // Completely remove the loader after animation
  const [loaderFinished, setLoaderFinished] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");

    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const center = window.innerHeight / 2;
      let active = "";

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();

        if (rect.top <= center && rect.bottom >= center) {
          active = section.id;
        }
      });

      setActiveSection(active);

      const currentScrollY = window.scrollY;

      if (currentScrollY < 50) {
        setShowDock(true);
      } else if (currentScrollY > lastScrollY + 10) {
        setShowDock(false);
      } else if (currentScrollY < lastScrollY - 10) {
        setShowDock(true);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /*
   * Lock scrolling while the loader is visible.
   */
  useEffect(() => {
    if (!loaderExiting && !loaderFinished) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [loaderExiting, loaderFinished]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {!loaderFinished && (
        <Preloader
          duration={4500}
          onExitStart={() => {
            /*
             * This starts the Hero movement at the
             * exact moment the preloader starts leaving.
             */
            setLoaderExiting(true);
          }}
          onFinish={() => {
            setLoaderFinished(true);
          }}
        />
      )}

      <div className="no-cursor">
        <CursorProvider>
          <ContactSection
            setIsNavigating={setIsNavigating}
          />

          <FloatingDock
            activeSection={activeSection}
            showDock={showDock}
            setIsNavigating={setIsNavigating}
          />

          <div
            style={{
              transform: loaderExiting
                ? "translateY(0)"
                : "translateY(100vh)",

              transition: `transform ${LOADER_EXIT_DURATION}ms cubic-bezier(.65,0,.24,1)`,

              willChange: "transform",
              pointerEvents: loaderExiting ? "auto" : "none"
            }}
          >
            <SmoothScroll>
              <div className="relative z-10 min-h-screen bg-white">
                <HomeSection />

                <ExperienceSection
                  isNavigating={isNavigating}
                />

                <ProjectsSection />

                <div
                  className="h-[5vh] rounded-b-full bg-black md:h-[10vh]"
                  style={{
                    backgroundImage: `
                      linear-gradient(
                        90deg,
                        rgba(255,255,255,0.099) 1px,
                        transparent 1px
                      )
                    `,
                    backgroundSize: "210px 190px",
                  }}
                />
              </div>

            </SmoothScroll>
          </div>
              <div
                id="contact"
                className="h-[95vh] md:h-[90vh]"
              />
        </CursorProvider>
      </div>
    </>
  );
}

export default V2Layout;